import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { RESET_PASSWORD_ACTION } from './consts';

export const resetPassword = createTaskAction(RESET_PASSWORD_ACTION);
